import { IBookmark, IBookmarkTag } from '../types/IBookmark';
import {APP_CONSTANTS} from "@/utilities/constants/AppConstants.ts";

interface MetadataResponse {
  title?: string;
  description?: string;
  image?: string;
  source?: string;
  tags?: IBookmarkTag[];
  categories?: string[];
}

interface TagsResponse {
  tags: string[];
  categories: string[];
}

class ApiService {
  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(`${APP_CONSTANTS.API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  }

 async getMetadata(url: string, existingData?: Partial<IBookmark>): Promise<MetadataResponse> {
    return this.request<MetadataResponse>('/metadata', {
      method: 'POST',
      body: JSON.stringify({
        url,
        bookmark: existingData,
      }),
    });
  }

 async getTags(url: string, existingData?: Partial<IBookmark>): Promise<TagsResponse> {
    return this.request<TagsResponse>('/metadata/tags', {
      method: 'POST',
      body: JSON.stringify({
        url,
        bookmark: existingData,
      }),
    });
  }
}

const apiService = new ApiService();

export { apiService as ApiService  };
